import {ACCEPT_OR_DECLINE_TERM,CLEAN_ACCEPTED_TERMS} from "../constants/ActionTypes";

export default function termsAndConditions(
  state = {
    acceptedTerms : []
  },
  action ) {


  switch (action.type) {

    case ACCEPT_OR_DECLINE_TERM:
      const acceptedTerms = state.acceptedTerms.filter(t => t !== action.termId );

      if(action.inputValue === true)
        acceptedTerms.push(action.termId);

      return Object.assign({}, state, {
        acceptedTerms: acceptedTerms
      });
    case CLEAN_ACCEPTED_TERMS:
      return Object.assign({}, state, {
        acceptedTerms : []
      });

    default:
      return state;
  }






}